import { render, staticRenderFns } from "./Trustees.vue?vue&type=template&id=6adad34d&scoped=true"
import script from "./Trustees.vue?vue&type=script&lang=js"
export * from "./Trustees.vue?vue&type=script&lang=js"
import style0 from "./Trustees.vue?vue&type=style&index=0&id=6adad34d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adad34d",
  null
  
)

export default component.exports